/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Professionals/view.blocks to change it.
import * as fromData from 'Simple/Data'
import DataVaxiomProfessionalsRelationshipsList from 'DesignSystem/DataVaxiomProfessionalsRelationshipsList/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Professionals({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Professionals/Professionals"
  
}) {
let profilePatientIdValueData = fromData.useDataValue({ viewPath,
context: 'profile_patient',
path: '_id',
})
  return (<React.Fragment
>
<DataVaxiomProfessionalsRelationshipsList
  viewPath={`${viewPath}/DataVaxiomProfessionalsRelationshipsList`}
 data="profile_patient._id"
 patient_id={profilePatientIdValueData}
 dtype="emploProfessionalRelationship"
 past={false}
/>
{children}
</React.Fragment>)
}